import { forwardRef, useId } from 'react'
import './fields.css'
const Input = forwardRef(function Input({ as: Tag = 'input', className = '', error, helperText, ...props }, ref) {
    const errorId = useId()
    const field = <Tag {...props} ref={ref} aria-invalid={error || props['aria-invalid'] || undefined} aria-describedby={[props['aria-describedby'], helperText ? errorId : ''].filter(Boolean).join(' ') || undefined} className={['uiField', error ? 'uiField--error' : '', className].filter(Boolean).join(' ')} />
    return helperText ? <><span className="uiFieldWithHelp">{field}</span><span id={errorId} className={error ? 'uiFieldError' : 'uiFieldHint'}>{helperText}</span></> : field
})
Input.uiField = true
export default Input
